{
  "Sign In - EventLive": "Anmelden - EventLive",
  "Forgot Password - EventLive": "Passwort vergessen - EventLive",
  "Password Restore Link Sent - EventLive": "Link zum Zurücksetzen gesendet - EventLive",
  "Event": "Event",
  "Event Details": "Eventdetails",
  "Details": "Details",
  "How to Go Live": "So gehst du live",
  "Multi-Camera": "Multikamera",
  "Add a room": "Raum hinzufügen",
  "Guest List": "Gästeliste",
  "Import Guests": "Gäste importieren",
  "Add a Guest": "Gast hinzufügen",
  "Event Analytics": "Event-Statistiken",
  "Purchase Successful": "Kauf erfolgreich",
  "Test EventLive": "EventLive testen",
  "Schedule Event": "Event planen",
  "Download everything": "Alles herunterladen",
  "Update Email": "E-Mail-Adresse ändern",
  "Help Us Grow": "Hilf uns zu wachsen",
  "Set a New Password - EventLive": "Neues Passwort festlegen - EventLive",
  "Are you sure?": "Bist du sicher?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "Daten konnten nicht geladen werden. Bitte prüfe deine Internetverbindung. Achte darauf, dass Zeitzone, Datum und Uhrzeit auf deinem Gerät richtig eingestellt sind.",
  "Couldn't save your profile": "Dein Profil konnte nicht gespeichert werden",
  "Link required": "Link erforderlich",
  "Overview": "Übersicht",
  "{days}-Day Event: {start} – {end}": "{days}-tägiges Event: {start} – {end}",
  "Close event": "Event schließen",
  "This sign-in link has expired": "Dieser Anmeldelink ist abgelaufen",
  "Couldn't sign you in from this link": "Die Anmeldung über diesen Link hat nicht funktioniert",
  "Please sign in to continue.": "Bitte melde dich an, um fortzufahren.",
  "Couldn't save your changes": "Deine Änderungen konnten nicht gespeichert werden",
  "TEST": "TEST",
  "Download EventLive for Mac": "EventLive für Mac herunterladen",
  "Download for": "Herunterladen für",
  "People": "Personen",
  "Team invite - EventLive": "Team-Einladung - EventLive"
}
